module.exports = __webpack_public_path__ + "img/attachment.560be4f8.png";